const DaftarAkunSearchCategories = ["pk", "nama_akun", "kode_akun"];

export default DaftarAkunSearchCategories;
